import { Locale, nb, sv } from 'date-fns/locale';
import { useTranslation } from 'react-i18next';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

const getDateFnsLocale = (language: string) => {
  const localeMap: Record<string, Locale> = {
    no: nb,
    se: sv,
  };
  return localeMap[language.toLowerCase()] || sv;
};

export const LocalizationProviderWrapper = ({ children }: { children: React.ReactNode }) => {
  const { i18n } = useTranslation();
  const locale = getDateFnsLocale(i18n.language);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={locale}>
      {children}
    </LocalizationProvider>
  );
};
